"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Bucket_1 = __importDefault(require("./Bucket"));
const guards_1 = require("./guards");
exports.encode = (args) => {
    var _a, _b;
    const { instance } = args;
    const type = (_a = args.type, (_a !== null && _a !== void 0 ? _a : typeof instance));
    const subtype = (_b = args.subtype, (_b !== null && _b !== void 0 ? _b : ''));
    const bucket = new Bucket_1.default();
    if (guards_1.isEncoder(instance)) {
        return instance.encode();
    }
    switch (type) {
        case 'boolean': {
            bucket.writeBoolean(instance);
            break;
        }
        case 'int8': {
            bucket.writeInt8(instance);
            break;
        }
        case 'uint8': {
            bucket.writeUint8(instance);
            break;
        }
        case 'int16': {
            bucket.writeInt16(instance);
            break;
        }
        case 'uint16': {
            bucket.writeUint16(instance);
            break;
        }
        case 'int32': {
            bucket.writeInt32(instance);
            break;
        }
        case 'uint32': {
            bucket.writeUint32(instance);
            break;
        }
        case 'int64': {
            bucket.writeInt64(BigInt(instance));
            break;
        }
        case 'uint64': {
            bucket.writeUint64(BigInt(instance));
            break;
        }
        case 'float32': {
            bucket.writeFloat32(instance);
            break;
        }
        case 'float64': {
            bucket.writeFloat64(instance);
            break;
        }
        case 'string': {
            bucket.writeString(instance);
            break;
        }
        case 'Date': {
            bucket.writeDate(instance);
            break;
        }
        case 'ByteString': {
            bucket.writeByteString(instance);
            break;
        }
        case 'Array': {
            if (instance === null) {
                bucket.writeInt32(-1);
                return bucket.bytes;
            }
            if (guards_1.isTypedArray(instance) || Array.isArray(instance)) {
                bucket.writeUint32(instance.length);
                for (const item of instance) {
                    const b = exports.encode({
                        instance: item,
                        type: subtype
                    });
                    bucket.write(b);
                }
            }
            break;
        }
        // all complex objects, structs and classes
        default: {
            for (const name of Object.getOwnPropertyNames(instance)) {
                if (guards_1.isNotNullObject(instance) && guards_1.keyInObject(instance, name)) {
                    const type = Reflect.getMetadata('design:type', instance, name);
                    const subtype = Reflect.getMetadata('design:subtype', instance, name);
                    const b = exports.encode({
                        instance: instance[name],
                        type,
                        subtype
                    });
                    bucket.write(b);
                }
            }
        }
    }
    return bucket.bytes;
};
